@if (hasValue) {
<ng-template component-host [spec]="componentSpec"></ng-template>
} @if (!hasValue) {
<empty [ngStyle]="isRequired() ? { color: 'red' } : {}">{{
  emptyMessage
}}</empty>
}
<ng-content></ng-content>
